module.exports = __webpack_public_path__ + "img/area-limit-btn-disabled.63242c4c.png";